import { TOKEN_NAME } from "./constDispatch";

const APIBASE = "https://admin.svietnamadventures.com/api/";
const RAG_APIBASE = "https://chatbot.svietnamadventures.com/api/v1/";
const GG_AUTH_LINK = APIBASE + "setting/auth";

const check401 = (response) => {
  if (response.status === 401) {
    sessionStorage.clear();
    window.location.href = "/login";
    throw new Error("Unauthorized");
  }
  return response;
};

const auth = () => ({
  "Content-Type": "application/json",
  Authorization: sessionStorage.getItem(TOKEN_NAME),
});

const plain = () => ({ "Content-Type": "application/json" });

const request = async (url, opts, callback, onError) => {
  try {
    const response = await fetch(url, opts);
    check401(response);
    const data = await response.json();
    callback(data);
  } catch (err) {
    console.log(err);
    callback(
      typeof onError === "function"
        ? onError(err)
        : onError !== undefined
          ? onError
          : err,
    );
  }
};

// Main API helpers
const get = (endpoint, callback, onError) =>
  request(
    APIBASE + endpoint,
    { method: "GET", headers: auth() },
    callback,
    onError,
  );
const post = (endpoint, body, callback, onError) =>
  request(
    APIBASE + endpoint,
    { method: "POST", headers: auth(), body: JSON.stringify(body) },
    callback,
    onError,
  );
const put = (endpoint, body, callback, onError) =>
  request(
    APIBASE + endpoint,
    { method: "PUT", headers: auth(), body: JSON.stringify(body) },
    callback,
    onError,
  );
const del = (endpoint, callback, onError) =>
  request(
    APIBASE + endpoint,
    { method: "DELETE", headers: auth() },
    callback,
    onError,
  );

// No-auth helpers
const getNoAuth = (endpoint, callback, onError) =>
  request(
    APIBASE + endpoint,
    { method: "GET", headers: plain() },
    callback,
    onError,
  );
const postNoAuth = (endpoint, body, callback, onError) =>
  request(
    APIBASE + endpoint,
    { method: "POST", headers: plain(), body: JSON.stringify(body) },
    callback,
    onError,
  );
const patchNoAuth = (endpoint, body, callback, onError) =>
  request(
    APIBASE + endpoint,
    { method: "PATCH", headers: plain(), body: JSON.stringify(body) },
    callback,
    onError,
  );

// RAG API helper (no auth)
const rag = (path, method, body, callback, onError) =>
  request(
    RAG_APIBASE + path,
    { method, headers: plain(), ...(body && { body: JSON.stringify(body) }) },
    callback,
    onError,
  );

// ============================================
// Booking
// ============================================
const API_get_bookings_sample = async (callback) =>
  get("booking_sample", callback);
const API_clone_bookings_sample = async (
  from_id,
  to_booking_number,
  callback,
) =>
  post(
    "booking_sample/clone_sample",
    {
      from_id: from_id.toString(),
      to_booking_number: to_booking_number.toString(),
    },
    callback,
  );
const API_search_bookings = async (textSearch, callback) =>
  post("booking/search", { text: textSearch.toString() }, callback);
const API_edit_booking_sample = async (id, data, callback) =>
  put("booking_sample/" + id, data, callback);
const API_get_bookings = async (callback) => get("booking", callback);
const API_edit_booking = async (id, data, callback) =>
  put("booking/" + id, data, callback);
const API_get_bookings_id = async (id, callback) =>
  get("booking/" + id, callback);
const API_delete_bookings_id = async (id, callback) =>
  del("booking/" + id, callback);
const API_delete_bookings_sample = async (id, callback) =>
  del("booking_sample/" + id, callback);
const API_clone_bookings = async (from_id, to_booking_number, callback) =>
  post(
    "booking/clone",
    {
      from_id: from_id.toString(),
      to_booking_number: to_booking_number.toString(),
    },
    callback,
  );

// ============================================
// Activities
// ============================================
const API_get_activities = async (callback) =>
  get("activities", callback, null);
const API_get_activities_simple = async (callback) =>
  get("activities/simple", callback, null);
const API_get_activities_not_hide = async (callback) =>
  get("activities/nothidden", callback, null);
const API_edit_activities = async (id, data, callback) =>
  put("activities/" + id, data, callback, null);
const API_clone_activities = async (from_id, code, callback) =>
  post(
    "activities/clone",
    { from_id: from_id.toString(), code },
    callback,
    null,
  );
const API_delete_activities = async (id, callback) =>
  del("activities/" + id, callback);

// ============================================
// Accommodation
// ============================================
const API_get_accommondation = async (callback) =>
  get("accommondation", callback);
const API_edit_accommondation = async (id, data, callback) =>
  put("accommondation/" + id, data, callback);
const API_clone_accommondation = async (from_id, code, callback) =>
  post("accommondation/clone", { from_id: from_id.toString(), code }, callback);
const API_delete_accommondation = async (id, callback) =>
  del("accommondation/" + id, callback);

// ============================================
// Users
// ============================================
const API_login = async (username, password, callback) =>
  postNoAuth(
    "user/login",
    { username: username.toString(), password: password.toString() },
    callback,
  );
const API_changepassword = async (body, callback) =>
  patch("user/", body, callback);
const API_AddUser = async (body, callback) => post("user/add", body, callback);
const API_ResetPassword = async (username, callback) =>
  get("user/resetpass/" + username, callback);
const API_GetUser = async (callback) => get("user", callback);
const API_DelUser = async (username, callback) =>
  del("user/" + username, callback);
const API_EditUser = async (body, callback) => put("user/edit", body, callback);

// ============================================
// Vendor
// ============================================
const API_get_vendor = async (callback) => {
  try {
    const res = await fetch(APIBASE + "vendor", {
      method: "GET",
      headers: auth(),
    });
    check401(res);
    const data = await res.json();
    if (data.success) callback(data.data);
    else {
      console.log(data.error);
      callback(null);
    }
  } catch (err) {
    console.log(err);
    callback(null);
  }
};
const API_get_vendor_att = async (id, callback) => {
  try {
    const res = await fetch(APIBASE + "vendor/vendorgroup/" + id, {
      method: "GET",
      headers: auth(),
    });
    check401(res);
    const data = await res.json();
    if (data.success) callback(data.data);
    else {
      console.log(data.error);
      callback(null);
    }
  } catch (err) {
    console.log(err);
    callback(null);
  }
};
const API_edit_vendor = async (id, data, callback) =>
  put("vendor/" + id, data, callback);
const API_get_vendors_id = async (id, callback) =>
  get("vendor/" + id, callback);
const API_delete_vendors_id = async (id, callback) =>
  del("vendor/" + id, callback);
const API_create_vendor = async (data, callback) =>
  post("vendor", data, callback);
const API_clone_vendor = async (from_id, to_code, callback) =>
  post(
    "vendor/clone",
    { from_id: from_id.toString(), to_code: to_code.toString() },
    callback,
  );

// ============================================
// Vendor Group
// ============================================
const API_get_vendorgroup = async (callback) => {
  try {
    const res = await fetch(APIBASE + "vendorgroup", {
      method: "GET",
      headers: auth(),
    });
    check401(res);
    const data = await res.json();
    if (data.success) callback(data.data);
    else {
      console.log(data.error);
      callback(null);
    }
  } catch (err) {
    console.log(err);
    callback(null);
  }
};
const API_edit_vendorgroup = async (id, data, callback) =>
  put("vendorgroup/" + id, data, callback);
const API_clone_vendorgroup = async (from_id, to_code, callback) =>
  post(
    "vendorgroup/clone",
    { from_id: from_id.toString(), to_code: to_code.toString() },
    callback,
  );
const API_delete_vendorgroup_id = async (id, callback) =>
  del("vendorgroup/" + id, callback);

// ============================================
// Operating
// ============================================
const API_get_operating_summary = async (callback) =>
  get("operating/summary", callback, null);
const API_get_operating_summary_booking_ref = async (booking_ref, callback) =>
  get("operating/summary/" + booking_ref, callback, null);
const API_get_operating_booking_id = async (id, callback) =>
  get("operating/booking_id/" + id, callback, null);
const API_confirm_operating = async (data, callback) =>
  post("operating/confirm", data, callback, null);
const API_delete_operating = async (id, callback) =>
  del("operating/" + id, callback, null);
const API_create_operation = async (booking_id, callback) =>
  post("operating/create", { booking_id }, callback, null);
const API_regenerate_operation = async (booking_id, callback) =>
  post("operating/regenerate", { booking_id }, callback, null);
const API_add_manually_operation = async (data, callback) =>
  post("operating/", data, callback, null);
const API_edit_operating = async (id, data, callback) =>
  put("operating/" + id, data, callback);

// ============================================
// Settings / Currency / Email
// ============================================
const API_get_currency_rate = async (callback) =>
  getNoAuth("setting/", callback, null);
const API_edit_currency_rate = async (id, data, callback) =>
  put("setting/" + id, data, callback);
const API_gg_send_email = async (data, callback) =>
  post("setting/send-email", data, callback, null);

// ============================================
// MessTool
// ============================================
const API_get_all_mess = async (callback) => get("messtool/", callback, null);
const API_clone_mess = async (from_id, to_code, callback) =>
  post(
    "messtool/clone",
    { from_id: from_id.toString(), to_code: to_code.toString() },
    callback,
  );
const API_delete_mess = async (id, callback) => del("messtool/" + id, callback);
const API_edit_mess = async (id, data, callback) =>
  put("messtool/" + id, data, callback);

// ============================================
// Calendar / Activities Message / Tax
// ============================================
const API_get_calendar_messages_tomorrow = async (query_string, callback) =>
  get("calendarmess/" + query_string, callback, null);
const API_apply_message_for_multiple_activities = async (data, callback) =>
  put("activities/message", data, callback);
const API_regen_tax_data = async (id, callback) =>
  get("tax/regenerate/" + id, callback, null);
const API_edit_tax_data = async (id, data, callback) =>
  put("tax/update/" + id, data, callback);
const API_get_activities_tax = async (callback) =>
  get("activity_tax", callback, null);
const API_edit_activities_tax = async (id, data, callback) =>
  put("activity_tax/" + id, data, callback);
const API_clone_activities_tax = async (from_id, to_code, callback) =>
  post("activity_tax/clone", { from_id, to_code }, callback);

// ============================================
// RAG Items
// ============================================
const API_get_rag_items = async (params, callback) => {
  let url = new URL(RAG_APIBASE + "rag");
  if (params.source) url.searchParams.append("source", params.source);
  if (params.type) url.searchParams.append("type", params.type);
  if (params.limit) url.searchParams.append("limit", params.limit);
  if (params.offset) url.searchParams.append("offset", params.offset);
  await request(url, { method: "GET", headers: plain() }, callback, () => ({
    items: [],
    total: 0,
  }));
};
const API_create_rag_item = async (body, callback) =>
  rag("rag", "POST", body, callback, (err) => ({ error: err.message }));
const API_update_rag_item = async (item_id, body, callback) =>
  rag("rag/" + item_id, "PUT", body, callback, (err) => ({
    error: err.message,
  }));
const API_delete_rag_item = async (item_id, callback) =>
  rag("rag/" + item_id, "DELETE", null, callback, (err) => ({
    error: err.message,
  }));
const API_reembed_rag_items = async (ids, callback) =>
  rag(
    "rag/reembed",
    "POST",
    ids && ids.length > 0 ? { ids } : {},
    callback,
    (err) => ({ error: err.message }),
  );

// ============================================
// System Prompt
// ============================================
const API_get_system_prompt = async (callback) =>
  rag("system-prompt", "GET", null, callback, (err) => ({
    error: err.message,
  }));
const API_create_system_prompt = async (prompt, callback) =>
  rag("system-prompt", "POST", { prompt }, callback, (err) => ({
    error: err.message,
  }));
const API_get_system_prompt_history = async (params, callback) => {
  let url = new URL(RAG_APIBASE + "system-prompt/history");
  if (params.limit) url.searchParams.append("limit", params.limit);
  if (params.offset) url.searchParams.append("offset", params.offset);
  await request(url, { method: "GET", headers: plain() }, callback, () => ({
    items: [],
    total: 0,
  }));
};
const API_activate_system_prompt = async (version, callback) =>
  rag("system-prompt/activate", "POST", { version }, callback, (err) => ({
    error: err.message,
  }));

// ============================================
// Chat Test
// ============================================
const API_chat_test_send = async (message, session_id, callback) => {
  let body = { message };
  if (session_id) body.session_id = session_id;
  rag("chat/test", "POST", body, callback, (err) => ({ error: err.message }));
};
const API_chat_test_clear = async (session_id, callback) =>
  rag("chat/test/" + session_id, "DELETE", null, callback, (err) => ({
    error: err.message,
  }));

// ============================================
// Agents
// ============================================
const API_get_agents = async (callback) =>
  rag("agents", "GET", null, callback, () => ({ items: [], total: 0 }));
const API_create_agent = async (body, callback) =>
  rag("agents", "POST", body, callback, (err) => ({ error: err.message }));
const API_update_agent = async (agent_id, body, callback) =>
  rag("agents/" + agent_id, "PUT", body, callback, (err) => ({
    error: err.message,
  }));
const API_delete_agent = async (agent_id, callback) =>
  rag("agents/" + agent_id, "DELETE", null, callback, (err) => ({
    error: err.message,
  }));

// ============================================
// Patterns
// ============================================
const API_get_patterns = async (params, callback) => {
  let url = new URL(RAG_APIBASE + "patterns");
  if (params.limit) url.searchParams.append("limit", params.limit);
  if (params.offset) url.searchParams.append("offset", params.offset);
  await request(url, { method: "GET", headers: plain() }, callback, () => ({
    items: [],
    total: 0,
  }));
};
const API_create_pattern = async (body, callback) =>
  rag("patterns", "POST", body, callback, (err) => ({ error: err.message }));
const API_update_pattern = async (group_id, body, callback) =>
  rag("patterns/" + group_id, "PUT", body, callback, (err) => ({
    error: err.message,
  }));
const API_delete_pattern = async (group_id, callback) =>
  rag("patterns/" + group_id, "DELETE", null, callback, (err) => ({
    error: err.message,
  }));

export {
  //booking
  API_get_bookings,
  API_clone_bookings,
  API_get_bookings_id,
  API_edit_booking,
  API_delete_bookings_id,
  API_search_bookings,
  // activities
  API_get_activities,
  API_get_activities_not_hide,
  API_edit_activities,
  API_clone_activities,
  API_delete_activities,
  API_get_activities_simple,
  // accommondation
  API_get_accommondation,
  API_edit_accommondation,
  API_clone_accommondation,
  API_delete_accommondation,
  //users
  API_login,
  API_changepassword,
  API_DelUser,
  API_ResetPassword,
  API_GetUser,
  API_AddUser,
  API_EditUser,
  //vendor
  API_get_vendor,
  API_clone_vendor,
  API_get_vendors_id,
  API_edit_vendor,
  API_delete_vendors_id,
  API_create_vendor,
  API_get_vendor_att,
  // vendorgroup
  API_get_vendorgroup,
  API_edit_vendorgroup,
  API_clone_vendorgroup,
  API_delete_vendorgroup_id,
  // operating
  API_get_operating_summary,
  API_get_operating_summary_booking_ref,
  API_get_operating_booking_id,
  API_confirm_operating,
  API_delete_operating,
  API_create_operation,
  API_regenerate_operation,
  API_add_manually_operation,
  API_edit_operating,
  // sample bookings
  API_get_bookings_sample,
  API_clone_bookings_sample,
  API_edit_booking_sample,
  API_delete_bookings_sample,
  // setting
  API_get_currency_rate,
  API_edit_currency_rate,
  // google
  API_gg_send_email,
  GG_AUTH_LINK,
  // messtool
  API_get_all_mess,
  API_clone_mess,
  API_delete_mess,
  API_edit_mess,

  // calendar mess
  API_get_calendar_messages_tomorrow,
  API_apply_message_for_multiple_activities,

  // tax
  API_regen_tax_data,
  API_edit_tax_data,
  // activities tax
  API_get_activities_tax,
  API_edit_activities_tax,
  API_clone_activities_tax,
  // rag
  API_get_rag_items,
  API_create_rag_item,
  API_update_rag_item,
  API_delete_rag_item,
  API_reembed_rag_items,
  // system prompt
  API_get_system_prompt,
  API_create_system_prompt,
  API_get_system_prompt_history,
  API_activate_system_prompt,
  // chat test
  API_chat_test_send,
  API_chat_test_clear,
  // agents
  API_get_agents,
  API_create_agent,
  API_update_agent,
  API_delete_agent,
  // patterns
  API_get_patterns,
  API_create_pattern,
  API_update_pattern,
  API_delete_pattern,
};
